const firebaseConfig = new URLSearchParams({
    apiKey: process.env['NX_PUBLIC_FIREBASE_API_KEY']!,
    authDomain: process.env['NX_PUBLIC_FIREBASE_AUTH_DOMAIN']!,
    projectId: process.env['NX_PUBLIC_FIREBASE_PROJECT_ID']!,
    storageBucket: process.env['NX_PUBLIC_FIREBASE_STORAGE_BUCKET']!,
    messagingSenderId: process.env['NX_PUBLIC_FIREBASE_MESSAGING_SENDER_ID']!,
    appId: process.env['NX_PUBLIC_FIREBASE_APP_ID']!,
    measurementId: process.env['NX_PUBLIC_FIREBASE_MEASUREMENT_ID']!
}).toString();

// Service worker URL w/config variables
const swUrl = `/public/firebase-messaging-sw.js?${firebaseConfig}`;
export let swRegistration: ServiceWorkerRegistration | null = null;

export async function registerServiceWorker(url: string = swUrl) {
    if ('serviceWorker' in navigator) {
        if (!swRegistration) swRegistration = await navigator.serviceWorker.register(url);

        if (swRegistration.waiting) {
            invokeServiceWorkerUpdateFlow(swRegistration);
        }

        //Detect Service Worker update available and wait for it to become installed
        swRegistration.addEventListener('updatefound', () => {
            if (swRegistration && swRegistration.installing) {
                //Wait until the new Service worker is actually installed (ready to take over)
                swRegistration.installing.addEventListener('statechange', () => {
                    if (swRegistration && swRegistration.waiting) {
                        //If there's an existing controller (previous Service Worker), show the prompt
                        //Ohterwise no action needed since the new one will be used
                        if (navigator.serviceWorker.controller) {
                            invokeServiceWorkerUpdateFlow(swRegistration);
                        }
                    }
                });
            }
        });
    }
}

//Ask users if they want to update right now
//Should be put into a react component eventually to have a proper UX/UI for the user
function invokeServiceWorkerUpdateFlow(registration: ServiceWorkerRegistration) {
    const val = window.confirm('There is a new version available. Would you like to update?');
    if (val) {
        if (registration.waiting) {
            registration.waiting.postMessage('SKIP_WAITING');
        }
    }
}
